import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import NestedRow from './components/NestedRow';
import clsx from 'clsx';
import { ArrowForwardIos } from '@material-ui/icons';
import useStyles from './styles';

const TableWithConfig = ({
  columnsConfig = [],
  rows = [],
  nestingConfig,
  ...props
}) => {
  const classes = useStyles();

  const renderTableHeader = () => {
    return columnsConfig.map((column) => (
      <TableCell key={column.id} style={{ width: column.width || 'auto' }}>
        {column.label}
      </TableCell>
    ));
  };

  const getCellDisplayedValue = (column, row) => {
    const { id, renderCell, renderCellContent } = column;

    if (renderCell) {
      return renderCell(row[id], row);
    }

    if (renderCellContent) {
      const cellContent = renderCellContent(row[id], row);
      return <TableCell key={column.id}>{cellContent}</TableCell>;
    }

    return <TableCell key={column.id}>{row[column.id]}</TableCell>;
  };

  const renderRow = (row) => {
    return (
      <TableRow key={row.id}>
        {columnsConfig.map((column) => getCellDisplayedValue(column, row))}
      </TableRow>
    );
  };

  const renderExtraCellForNesting = ({
    isExtended,
    nestingExtendAction,
    isChild,
    hasChildren,
  }) => {
    if (isChild) {
      return <TableCell></TableCell>;
    }
    return (
      <TableCell onClick={hasChildren ? nestingExtendAction : undefined}>
        <span>
          <ArrowForwardIos
            className={clsx(classes.arrowIcon, {
              [classes.extended]: isExtended,
              [classes.disabled]: !hasChildren,
            })}
          />
        </span>
      </TableCell>
    );
  };

  const renderNestedRow = ({
    row,
    nestingExtendAction,
    isExtended,
    isChild,
    hasChildren,
  }) => {
    return (
      <TableRow key={row.id}>
        {renderExtraCellForNesting({
          isExtended,
          nestingExtendAction,
          isChild,
          hasChildren,
        })}
        {columnsConfig.map((column) => getCellDisplayedValue(column, row))}
      </TableRow>
    );
  };

  const renderTableBody = () => {
    return rows.map((row) => {
      if (nestingConfig) {
        return (
          <NestedRow
            key={row.id}
            row={row}
            columnsConfig={columnsConfig}
            renderRow={renderNestedRow}
            nestingConfig={nestingConfig}
          />
        );
      }

      return renderRow(row);
    });
  };

  return (
    <Table {...props}>
      <TableHead>
        <TableRow>
          {nestingConfig && <TableCell width="30px"></TableCell>}
          {renderTableHeader()}
        </TableRow>
      </TableHead>
      <TableBody>{renderTableBody()}</TableBody>
    </Table>
  );
};

TableWithConfig.propTypes = {};

export default TableWithConfig;
